module.exports = new __parcel__URL__("shop_machines_pirate_nation_wood_galleon.9fbae74f.png").toString();